/* eslint-disable max-len */
import React from 'react';

const UnorderedListIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <path
            d="M4.25 15c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25S3 16.94 3 16.25 3.56 15 4.25 15zm13.5.75v1h-10v-1h10zM4.25 9c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25S3 10.94 3 10.25 3.56 9 4.25 9zm13.5.75v1h-10v-1h10zM4.25 3c.69 0 1.25.56 1.25 1.25S4.94 5.5 4.25 5.5 3 4.94 3 4.25 3.56 3 4.25 3zm13.5.75v1h-10v-1h10z"
            transform="translate(-501.000000, -80.000000) translate(498.000000, 77.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default UnorderedListIcon;
